<template>
  <el-dialog
    :close-on-click-modal="false"
    class="image-dialog"
    title="选择图片"
    :visible.sync="visible"
    width="1200px"
    :before-close="handleClose"
  >
    <div id="imageDialog" style="height: 60vh; overflow: auto">
      <div class="left">
        <MenuImage @select="handleMenuSelect"></MenuImage>
      </div>
      <div class="right">
        <div class="tab-body" style="margin-top: 0">
          <el-checkbox
            @change="handleSelect"
            style="float: left;margin: 4px 16px 0 0;"
            v-model="isSelect"
            >全选</el-checkbox
          >
          <el-input
            v-model="form.picName"
            placeholder="搜索图片名称"
            size="small"
            suffix-icon="el-icon-search"
            style="width: 300px; float: left"
            @change="getData"
          ></el-input>
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
          />
          <div class="product-list">
            <template v-for="(item, index) in tableData">
              <div class="pro-card">
                <div @click="handleChecked(item)" class="card-img">
                  <!-- item.thumb -->
                  <img
                    :style="{ height: '157' + 'px' }"
                    style="width: 100%"
                    :src="
                      `${item.picUrl}?x-oss-process=image/resize,m_fill,h_500,w_500`
                    "
                    lazy
                  />
                </div>
                <div class="card-info">
                  <div class="info-div">
                    <div class="detail">
                      <div :title="item.picName" class="product-title">
                        {{ item.picName }}
                      </div>
                      <div class="product-desc">
                        {{ item.picWidth }}px * {{ item.picHeight }}px
                      </div>
                    </div>
                  </div>
                </div>
                <div class="checkbox">
                  <el-checkbox v-model="item.checked"></el-checkbox>
                </div>
              </div>
            </template>
          </div>
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="form.pageNum"
            :limit.sync="form.pageSize"
            @pagination="getData"
          />
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { getMapList, getMapTypeList } from "@/api/map/map"
import { mapGetters } from "vuex"
import MenuImage from "./MenuImage"

let timer = null

export default {
  components: { MenuImage },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "visible",
    event: "change",
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          this.form = {
            pageNum: 1,
            pageSize: 30,
            keyword: "",
            typeId: "",
          }

          this.$nextTick(() => {
            document.querySelector("#imageDialog").scrollTop = 0
          })

          this.getData()
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 30,
        picName: "",
        typeId: "",
      },
      productList: [],
      tableData: [],
      total: 0,
      loading: false,
      imageHeight: "",
      imageType: "02",
      isSelect: false,
    }
  },
  methods: {
    getData() {
      this.startLoading()
      this.form.mapSource = this.imageType
      this.form.delFlag = 1
      getMapList(this.form)
        .then((res) => {
          for (let record of res.rows) {
            record.showTitle = true
            record.currentProduct = 0
            record.checked = false
          }
          this.tableData = res.rows
          this.total = res.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    handleChecked(item) {
      for (let record of this.tableData) {
        // record.checked = false
      }
      item.checked = !item.checked
    },
    handleSelectSku(item, number) {
      item.currentProduct = number
    },
    handleSelect() {
      for (let record of this.tableData) {
        record.checked = this.isSelect
      }
    },
    handleClose() {
      this.$emit("change", false)
    },
    handleConfirm() {
      let array = this.tableData.filter((item) => {
        return item.checked
      })

      this.$emit("select", array)
      this.$emit("change", false)
    },
    handleMenuSelect(value, type) {
      this.imageType = type
      this.form.typeId = value
      this.getData()
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.product-list {
  position: relative;
}
.productPanInfo,
.imgPanInfo {
  position: absolute;
  width: 240px;
  left: 338px;
  top: -57px;
  background: rgba(246, 246, 246, 0.95);
  box-shadow: 0px 0px 8px 0px rgba(153, 153, 153, 1);
  border-radius: 2px;
  padding: 10px 10px;
  color: rgb(77, 77, 77);
  overflow: hidden;
  z-index: 99;
  line-height: 24px;
  .imgPanInfoName {
  }
  .imgPanInfoStandard {
    font-size: 12px;
    color: #aaaaaa;
  }
  .color-picker-list {
    overflow: hidden;
    margin-left: -4px;
  }
  .color-picker-list li,
  .color-picker-list-hover li,
  .mgg-preview-colors li {
    background-color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: #d6d2d2 solid 1px;
    margin-left: 2px;
    padding: 1px;
    float: left;
  }

  .color-picker-list li.cur,
  .mgg-preview-colors li.cur {
    border: rgb(236, 78, 43) solid 2px;
  }

  .color-picker-list li a,
  .color-picker-list-hover li a,
  .mgg-preview-colors li a {
    width: 24px;
    height: 24px;
    display: table;
  }
}
.left {
  float: left;
  width: 225px;
}
.right {
  float: left;
  width: 927px;
}
.product-desc {
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.image-dialog {
  ::v-deep .el-form-item__content {
    padding: 8px 20px;
  }

  .product-list {
    overflow: hidden;
    ::v-deep .pro-card:first-child {
    }
    ::v-deep .pro-card:last-child {
    }

    .pro-card {
      width: calc(20% - 16px);
      float: left;
      box-sizing: border-box;
      margin: 4px 12px 12px 4px;
      padding: 16px 16px 6px 16px;
      background: #ffffff;
      border: 1px solid rgb(221, 221, 221);
      position: relative;
      .detail {
        line-height: 30px;
      }
      .unit {
        font-size: 12px;
      }
      .card-img {
        cursor: pointer;
      }
      .image {
        padding: 16px;
        cursor: pointer;
      }
      .text {
        overflow: hidden;
        font-size: 14px;
      }
      .product-title {
        font-size: 14px;
        box-sizing: border-box;
        padding-bottom: 4px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 20px;
        text-align: center;
      }
      .product-tag {
        line-height: 14px;
        margin: 0 0 10px 0;
        overflow: hidden;
        .left {
          display: inline-block;
          font-size: 12px;
          padding: 2px 6px;
          background: #4934b2;
          border-radius: 5px;
          color: #ffffff;
        }
      }
      .factory {
        border-top: 1px solid #ebeef5;
      }
      .price {
        float: left;
        color: #4934b2;
        font-size: 18px;
        font-weight: bold;
      }
      .date {
        float: right;
      }
    }
    .pro-card:hover {
      cursor: auto;
      color: #000 !important;
      box-shadow: 0 0px 6px 0 #4934b2;
      transition: all 0.35s;
    }
  }
  .checkbox {
    position: absolute;
    right: 21px;
    top: 16px;
  }
}
.form-body {
  margin-right: 8px;
  padding-bottom: 6px;
  padding: 10px 0;
}
.form {
  padding: 0 16px;
}

.sku-img-list {
  clear: both;
  width: 223px;
}
.sku-img-list .prev {
  float: left;
  margin-right: 2px;
}
.sku-img-list .next {
  float: right;
}
.sku-img-list .prev,
.tab-body .pro-card .pro-content .sku-img-list .next {
  display: block;
  font-family: "宋体";
  text-align: center;
  width: 10px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
  text-decoration: none;
}
.sku-img-list .img-content {
  position: relative;
  height: 40px;
  overflow: hidden;
}
.sku-img-list ul {
  position: absolute;
  width: 99999px;
  height: 40px;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-left: 0px;
  list-style-type: none;
}
.sku-img-list ul li {
  float: left;
  width: 40px;
  text-align: center;
  cursor: pointer;
  border: 1px solid #ebeef5;
  margin-right: 4px;
}
.sku-img-list ul li img {
  width: 40px;
  height: 40px;
}
.sku-img-list ul li img:hover {
}
.price-gradient-box {
  overflow: hidden;
  width: 100%;
  background: #fff;
  z-index: 100;
  transform: translateZ(1000px);
  font-size: 12px;
}
.price-gradient-box .weight-box {
  height: 42px;
  line-height: 42px;
  border: 1px solid #ededed;
  text-align: center;
}
.price-gradient-box .weight-box div:not(:first-child) {
  border-left: 1px solid #ededed;
}
.price-gradient-box > div {
  background: #fff;
}
.price-gradient-box:hover,
.com-pt-img:hover ~ .price-gradient-box {
  bottom: 5px;
  left: 0;
  overflow: hidden;
  z-index: 100;
  transform: translateZ(1000px);
}
.price-gradient-box .swiper-slide {
  text-align: center;
  border: 1px solid #ededed;
  padding: 10px 0;
}
.price-gradient-box .swiper-slide + .swiper-slide {
  border-left: none;
}
.product-swiper-box .next-btn,
.product-swiper-box .per-btn,
.price-gradient-box .next-btn,
.price-gradient-box .per-btn {
  z-index: 2;
  top: 60px;
  padding: 5px;
  width: 20px;
  height: 20px;
  line-height: 0px;
  background: rgba(235, 246, 255, 0.5);
  text-align: center;
}
.w50 {
  width: 50% !important;
}
.flex-x-full {
  -webkit-box-pack: justify;
  -moz-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.flex-row {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
}
.red {
  color: #ff4d3a !important;
}
.c153 {
  color: rgb(153, 153, 153);
}
.filter {
  background: #ffffff;
  border-top: 1px solid rgb(221, 221, 221);
  margin: 4px 0 0 0;
  overflow: hidden;
  padding: 12px 16px 0 16px;
}
.left {
  float: left;
}
.right {
  float: right;
}
.is-select {
  border: 1px solid #4934b2 !important;
}
#custom-online .tab-body .card-img:hover {
  // .card-info .info-div {
  //   opacity: 0;
  // }
  // .card-info .btn-div {
  //   opacity: 1;
  // }
}
#custom-online .tab-body .pro-card .card-info {
}
</style>
